import { http } from "./http";

export type EpsonRtProblem = {
  code: string;
  severity: "HIGH" | "MEDIUM" | "LOW";
  title: string;
  detail: string;
  action: string;
  recoverable: boolean;
};

export type EpsonRtProbe = {
  ok: boolean;
  connected: boolean;
  lamp: "green" | "red";
  checkedAt: string;
  host: string;
  port: number;
  latencyMs: number | null;
  driver: {
    name: string;
    protocol: string;
    path: string;
    description: string;
  };
  problems: EpsonRtProblem[];
  fields: Record<string, string>;
  rawExcerpt: string;
  message: string;
};

export type EpsonRtRecover = {
  requestedCode: string;
  stillPresent: boolean;
  sentReset: boolean;
  note: string;
  probe: EpsonRtProbe;
};

export const epsonRtApi = {
  status(token: string, host: string, port: number) {
    return http<EpsonRtProbe>("/pos/epson-rt/status", { method: "POST", body: JSON.stringify({ host, port }) }, token);
  },
  recover(token: string, host: string, port: number, code: string) {
    return http<EpsonRtRecover>(
      "/pos/epson-rt/recover",
      { method: "POST", body: JSON.stringify({ host, port, code }) },
      token,
    );
  },
};
